// authApi.js
import { API_CONFIG} from "../../../utils/api-config";
import fetchWithAuth from "../../../utils/apiAthurization";

export const StoreDepartmentalSubSpeciality = async (data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/diagnosis/departmental-sub-specialities`,'POST',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetDepartmentalSubSpecialities = async () => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/diagnosis/departmental-sub-specialities`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "diagnosis/departmental-sub-specialities fetching failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetDepartmentalSubSpecialityById = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/diagnosis/departmental-sub-specialities/${id}`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const UpdateDepartmentalSubSpeciality = async (id,data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/diagnosis/departmental-sub-specialities/${id}`,'PATCH',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const DeleteDepartmentalSubSpeciality = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/diagnosis/departmental-sub-specialities/${id}`,'DELETE'
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};